import * as types from './GenericOrderTypes';
import { assign } from '../../../../shared/Assign';
import InitialState from './GenericOrderInitialState';

export default function genericOrderReducer(
    state: any = InitialState.state,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.NEW_GENERIC_ORDER_SUCCESS: {
            const newState = assign({}, state);
            newState.model = action.result;
            return newState;
        }
        default:
            return state;
    }
}
